module.exports = __webpack_public_path__ + "static/media/covid-19-protect-yourself-news.a3e29e83.jpg";